// extracted by mini-css-extract-plugin
export default {"primaryButton":"primaryButton__WnMig","inline":"inline__1whb-","button":"button__TgRTP","disabled":"disabled__RhcTz","btnIcon":"btnIcon__26F6P"};